import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Thankyounew = lazy(() => retry(()=> import(/* webpackChunkName: "Thankyounew" */ "./Thankyounew")));

export default Thankyounew;